const style = {
  name: {
    color: `black`,
    fontSize: `16px`
  },
  country: {
    fontSize: `14px`
  },
  info: {
    fontSize: `14px`
  },
  icon: {
    display: `inline-block`,
    width: `14px`,
    height: `14px`,
    color: `black`,
    marginRight: `8px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/style/user.js